// extracted by mini-css-extract-plugin
module.exports = {"mortgage-offer-card-template-wrapper":"a10a3f92e9--mortgage-offer-card-template-wrapper--WM64N"};